import { useState, useEffect } from "react";

export function useGravatarUrl(email: string | null | undefined, size = 40): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!email) { setUrl(null); return; }
    const normalized = email.trim().toLowerCase();
    crypto.subtle
      .digest("SHA-256", new TextEncoder().encode(normalized))
      .then((buf) => {
        const hex = Array.from(new Uint8Array(buf))
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
        // d=identicon: Gravatar serves a deterministic generated avatar (HTTP 200)
        // when the email has no account, instead of d=404 which logs a console
        // 404 on every avatar render for users without a Gravatar. (#1431)
        setUrl(`https://www.gravatar.com/avatar/${hex}?s=${size}&d=identicon`);
      })
      .catch(() => setUrl(null));
  }, [email, size]);

  return url;
}
